<div class="tab-container" #sourceListContainer>
  <div class="ft-form-row">
    <span class="title">{{ title }}</span>
  </div>

  <div class="ft-form-row col1-v100">
    <div class="ft-form-input">
      <div class="icon-input-container">
        <input class="icon-input" placeholder="{{ 'ph_search_source' | translate }}" type="text"
          [(ngModel)]="searchPhrase" />
        <div class="icon-input-wrap">
          <img src="/assets/images/icons/search.svg" width="30" height="30" />
        </div>
      </div>
    </div>
  </div>

  <div class="place-wrapper">
    <div class="tab-forms">
      <div id="place-content">
        <div class="ft-form" *ngIf="placeL?.length == 0 || placeL == null">
          <div class="ft-form-row no-record-row">
            <div class="no-record">
              <span>{{ "lbl_no_place" | translate }}</span>
            </div>
          </div>
        </div>

        <div id="place-list-container" #placeListContainer *ngIf="placeL?.length > 0">
          <div *ngFor="let place of filteredPlaces" class="item" 
          [ngClass]="{ 'highlighted-place': editedPlaceId === place.id }">

            <div class="item-image" style="background-color: #e6eed7;">
              <img [src]="getTimeStampedImageUrl(place?.mediaUrl)" (error)="onImageLoadingError($event)">
            </div>

            <div class="item-content">
              <span class="label-m-grey text-ellipsis-1">{{ place.rawData }}</span>
              <span class="label-s-grey text-ellipsis-1">({{ place.used }}x)</span>
            </div>

            <div class="item-options">
              <img src="/assets/images/icons/edit.svg" class="ft-btn-round-green-base" width="23" height="23"
                (click)="editPlace(place)" />
              <img src="/assets/images/icons/delete.svg" class="ft-btn-round-green-base" width="23" height="23"
                (click)="deletePlace(place)" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>